// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1

import { memo } from 'react'
import type { ReactNode } from 'react'
import { ThemeToggle } from '@/components/ui/ThemeToggle'

interface AuthLayoutProps {
  children: ReactNode
}

const logoStackClass =
  '[&>img]:col-start-1 [&>img]:row-start-1 [&>img]:w-full [&>img]:h-auto [&>img]:max-w-full'

const BrandPanel = memo(function BrandPanel() {
  return (
    <>
      {/* Left — brand panel (desktop only) */}
      <div className="hidden md:flex flex-col items-end justify-center bg-surface py-16 pl-8 pr-10">
        <span className={`inline-grid w-72 max-w-full ${logoStackClass}`}>
          <img
            src="/etapsky_vertical_logo.svg"
            alt="Etapsky"
            className="opacity-100 transition-opacity duration-200 ease-out dark:opacity-0"
          />
          <img
            src="/etapsky_vertical_logo_on_dark.svg"
            alt=""
            className="opacity-0 transition-opacity duration-200 ease-out dark:opacity-100"
            aria-hidden={true}
          />
        </span>
      </div>

      {/* Mobile-only logo — flex centers horizontally; grid `self-center` did not (align vs justify) */}
      <div className="flex w-full shrink-0 justify-center px-4 pb-6 pt-8 md:hidden">
        <span className={`inline-grid w-[min(11rem,calc(100vw-2rem))] ${logoStackClass}`}>
          <img
            src="/etapsky_vertical_logo.svg"
            alt="Etapsky"
            className="opacity-100 transition-opacity duration-200 ease-out dark:opacity-0"
          />
          <img
            src="/etapsky_vertical_logo_on_dark.svg"
            alt=""
            className="opacity-0 transition-opacity duration-200 ease-out dark:opacity-100"
            aria-hidden={true}
          />
        </span>
      </div>
    </>
  )
})

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="relative min-h-screen grid grid-cols-1 md:grid-cols-2 md:gap-x-8 bg-surface">
      <div className="absolute top-4 right-4 z-10">
        <ThemeToggle />
      </div>

      <BrandPanel />

      {/* Right — form panel (mobile: centered column; md+: left-aligned in pane) */}
      <div className="flex flex-col items-center justify-center bg-surface px-4 py-8 sm:px-6 md:items-start md:py-12 md:pl-10 md:pr-16">
        <div className="w-full max-w-sm md:mx-0 mx-auto">
          {children}
        </div>
      </div>

    </div>
  )
}
